import { render, staticRenderFns } from "./HomeCouponCampaignModal.vue?vue&type=template&id=622284f5&scoped=true"
import script from "./HomeCouponCampaignModal.vue?vue&type=script&lang=js"
export * from "./HomeCouponCampaignModal.vue?vue&type=script&lang=js"
import style0 from "./HomeCouponCampaignModal.vue?vue&type=style&index=0&id=622284f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622284f5",
  null
  
)

export default component.exports